import api from "./api";

async function fetchTransactions(query, { signal } = {}) {
  const queryString = query ? `?${query}` : "";
  const response = await api.get(`api/transactions${queryString}`, { signal });
  return response.data;
}

async function getPayment(id, type) {
  try {
    const response = await api.get(`api/transactions/${id}?paymentMethodKey=${type}`);
    return response.data;
  } catch (error) {
    return [];
  }
}

// A refund on its own, for refund rows that have no payment (unreferenced POS refunds).
async function getRefund(refundId) {
  const response = await api.get(`api/transactions/refunds/${refundId}`);
  return response.data;
}

async function downloadReceipt(id) {
  const response = await api.post(`api/transactions/${id}/receipt`, null, {
    responseType: "blob",
  });
  return response;
}

// Labels hang off the transaction — the refund on refund rows, the payment otherwise — but the
// route is keyed on the payment id, with refundId narrowing it. Matches the drawer's header id.
function labelQuery(refundId) {
  return refundId ? `?refundId=${refundId}` : "";
}

async function getTransactionLabels(paymentId, refundId) {
  const response = await api.get(
    `api/transactions/${paymentId}/labels${labelQuery(refundId)}`,
  );
  return response.data;
}

// Both throw on error so callers can roll back optimistic updates.
async function setTransactionLabel(paymentId, refundId, type) {
  await api.put(
    `api/transactions/${paymentId}/labels/${type}${labelQuery(refundId)}`,
  );
}

async function removeTransactionLabel(paymentId, refundId, type) {
  await api.delete(
    `api/transactions/${paymentId}/labels/${type}${labelQuery(refundId)}`,
  );
}

export {
  fetchTransactions,
  getPayment,
  getRefund,
  downloadReceipt,
  getTransactionLabels,
  setTransactionLabel,
  removeTransactionLabel,
}
